import { Component, computed, input, OnInit, output, signal } from '@angular/core';
import { delay } from '@gametailors/web-core/misc';
import {
  RidAssessmentToast,
  RidContentCard,
  RidMechanicBackground,
  RidMechanicContent,
  RidMechanicTitle,
  RidMechanicWrapper,
  RidTopBar,
} from '../../components';
import { formatNumberWithThousandsSeparator } from '../../utils/math.utils';
import { AudioEffectPlayer } from '../../utils/audio.utils';

@Component({
  selector: 'rid-flash-number',
  imports: [RidMechanicBackground, RidMechanicWrapper, RidTopBar, RidMechanicContent, RidAssessmentToast, RidContentCard, RidMechanicTitle],
  templateUrl: './rid-flash-number.html',
  host: {
    class: 'block',
  },
})
export class RidFlashNumber implements OnInit {
  numbers = input.required<number[]>();
  visibilityDurationPerDigit = input(1000);
  guessDuration = input(3500);

  index = signal(0);
  number = computed(() => this.numbers()[this.index()]);
  formattedNumber = computed(() => formatNumberWithThousandsSeparator(this.number()));
  state = signal<'VISIBLE' | 'HIDDEN' | 'ANSWER'>('VISIBLE');

  finished = output<void>();

  async next() {
    const isLastIndex = this.index() === this.numbers().length - 1;

    if (isLastIndex) {
      this.finished.emit();
    } else {
      this.state.set('HIDDEN');
      await delay(750);
      this.index.set(this.index() + 1);
      await this.flash();
    }
  }

  markCorrect() {
    AudioEffectPlayer.play('CORRECT');
    return this.next();
  }

  markIncorrect() {
    AudioEffectPlayer.play('INCORRECT');
    return this.next();
  }

  async ngOnInit() {
    await this.flash();
  }

  async flash() {
    this.state.set('VISIBLE');
    await delay(this.visibilityDurationPerDigit() * Math.abs(this.number()).toString().length);
    this.state.set('HIDDEN');
    await delay(this.guessDuration());
    this.state.set('ANSWER');
  }
}
